import { ConfigurationColors } from '@tink/config/src/tinkLinkConfig';

type Props = Partial<Pick<ConfigurationColors, 'backgroundColor' | 'primaryColor'>>;

export const ConnectToBankIcon = ({ primaryColor, backgroundColor }: Props) => (
  <svg width="26" height="46" viewBox="0 0 26 46" fill="none">
    <path d="M1.58396 23.2244V27.9883" stroke={backgroundColor} strokeLinecap="square" />
    <path d="M5.08786 23.2244V27.9883" stroke={backgroundColor} strokeLinecap="square" />
    <path d="M8.59128 23.2244V27.9883" stroke={backgroundColor} strokeLinecap="square" />
    <path d="M12.0952 23.2244V27.9883" stroke={backgroundColor} strokeLinecap="square" />
    <path d="M1.58396 30.3701H12.0951" stroke={backgroundColor} strokeLinecap="square" />
    <path d="M2.40387 20.938L6.83955 17.3193L11.2752 20.938H2.40387Z" stroke={backgroundColor} />
    <rect x="1" y="1" width="24" height="44" rx="2.604" stroke={primaryColor} strokeWidth="1.5" />
    <rect x="7.5625" y="3.25" width="10.937" height="2.25" rx="1.125" fill={primaryColor} />
    <rect x="3" y="9" width="20" height="33" rx="1" fill={primaryColor} />
    <path d="M7.70309 24.2244V28.9883" stroke={backgroundColor} strokeLinecap="square" />
    <path d="M11.3593 24.2244V28.9883" stroke={backgroundColor} strokeLinecap="square" />
    <path d="M15.0156 24.2244V28.9883" stroke={backgroundColor} strokeLinecap="square" />
    <path d="M18.6714 24.2244V28.9883" stroke={backgroundColor} strokeLinecap="square" />
    <path d="M7.70309 31.3701H18.6713" stroke={backgroundColor} strokeLinecap="square" />
    <path d="M8.54509 21.938L13.1872 18.3087L17.8293 21.938H8.54509Z" stroke={backgroundColor} />
  </svg>
);
